import { apiConnector } from "../apiconnector";
import toast from "react-hot-toast";
import { adminEndpoints } from "../apis";

// Send an invite to an employee
export const createEmployeeInvite = async (data, token) => {
  try {
    const response = await apiConnector(
      "POST",
      adminEndpoints.CREATE_EMPLOYEE_INVITE_API,
      data,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Employee invite sent");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to send invite");
    throw err;
  }
};

export const getMyTeamsData = async (token) => {
  try {
    const response = await apiConnector("GET", adminEndpoints.GET_MY_TEAMS_API,null,
      { Authorization: `Bearer ${token}` });
    return response.data;
  } catch (error) {
    toast.error("Error fetching My Teams data");
    return null;
  }
};

// Delete admin account
export const deleteAdminAccount = async (token) => {
  try {
    const response = await apiConnector(
      "DELETE",
      adminEndpoints.DELETE_ADMIN_ACCOUNT_API,
      null,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Admin account deleted");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to delete admin account");
    throw err;
  }
};

// Remove an employee from the team
export const removeEmployee = async (employeeId, token) => {
  try {
    const response = await apiConnector(
      "DELETE",
      adminEndpoints.REMOVE_EMPLOYEE_API(employeeId),
      null,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Employee removed successfully");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to remove employee");
    throw err;
  }
};

// Get all drawing sheets created by admin
export const getAllDrawingSheets = async (token) => {
  try {
    const response = await apiConnector(
      "GET",
      adminEndpoints.GET_DRAWINGSHEETS_API,
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch drawing sheets");
    throw err;
  }
};

// Get team members for a particular drawing sheet
export const getDrawingSheetTeam = async (drawingSheetId, token) => {
  try {
    const response = await apiConnector(
      "GET",
      adminEndpoints.GET_DRAWINGSHEET_TEAM_API(drawingSheetId),
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch team data");
    throw err;
  }
};

// Get admin dashboard data
export const getAdminDashboardData = async (token) => {
  try {
    const response = await apiConnector(
      "GET",
      adminEndpoints.GET_ADMIN_DASHBOARD_DATA_API,
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch dashboard data");
    throw err;
  }
};

// Get assigned tasks for a specific employee
export const getEmployeeAssignedTask = async (employeeId) => {
  try {
    const response = await apiConnector(
      "GET",
      adminEndpoints.GET_EMPLOYEE_ASSIGNED_TASK_API(employeeId),
      null, 
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch employee tasks");
    throw err;
  }
};

// Get invited employees
export const getInvitedEmployees = async (token) => {
  try {
    const response = await apiConnector(
      "GET",
      adminEndpoints.GET_INVITED_EMPLOYEES_API,
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch invited employees");
    throw err;
  }
};

// Get employee node status
export const getEmployeeNodeStatus = async (token) => {
  try {
    const response = await apiConnector(
      "GET",
      adminEndpoints.GET_EMPLOYEE_NODE_STATUS_API,
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch employee node status");
    throw err;
  }
};



// import axios from "axios";
// import { adminEndpoints } from "../apis";

// // Get invited employees
// export const getInvitedEmployees = async (adminId, token) => {
//   try {
//     const response = await axios.get(adminEndpoints.GET_INVITED_EMPLOYEES_API(adminId), {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching invited employees:", error);
//     throw error;
//   }
// };

// // Get employee node status
// export const getEmployeeNodeStatus = async (adminId, token) => {
//   try {
//     const response = await axios.get(adminEndpoints.GET_EMPLOYEE_NODE_STATUS_API(adminId), {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching employee node status:", error);
//     throw error;
//   }
// };

// // Invite employee
// export const inviteEmployee = async (email, token) => {
//   try {
//     const response = await axios.post(
//       adminEndpoints.CREATE_EMPLOYEE_INVITE_API,
//       { email },
//       {
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error inviting employee:", error);
//     throw error;
//   }
// };

// // Remove employee
// export const removeEmployee = async (adminId, employeeId, token) => {
//   try {
//     const response = await axios.delete(
//       adminEndpoints.REMOVE_EMPLOYEE_API(adminId, employeeId),
//       {
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error removing employee:", error);
//     throw error;
//   }
// };

// // Delete admin account
// export const deleteAdminAccount = async (adminId, token) => {
//   try {
//     const response = await axios.delete(
//       adminEndpoints.DELETE_ADMIN_ACCOUNT_API(adminId),
//       {
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error deleting admin account:", error);
//     throw error;
//   }
// };
